import { render } from "./BurgerForm.vue?vue&type=template&id=e012f5b8&scoped=true"
import script from "./BurgerForm.vue?vue&type=script&lang=js"
export * from "./BurgerForm.vue?vue&type=script&lang=js"

import "./BurgerForm.vue?vue&type=style&index=0&id=e012f5b8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e012f5b8"]])

export default __exports__